import "core-js/modules/es.function.name.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "flex justify-between gap-0 w-full !bg-surface-0 border-t py-1.5 pr-0 mr-3.5 border-surface-100 relative"
};
var _hoisted_2 = {
  class: "flex flex-col justify-center gap-0 w-full min-w-[15.625rem]"
};
var _hoisted_3 = {
  class: "text-surface-700 text-sm font-semibold ellipsis truncate max-w-[235px]"
};
var _hoisted_4 = {
  class: "text-surface-500 text-xs font-normal"
};
var _hoisted_5 = {
  class: "flex flex-col items-end w-full min-w-[5.313rem] font-normal text-surface-900 text-xs gap-3"
};
var _hoisted_6 = {
  class: ""
};
var _hoisted_7 = {
  class: ""
};
import { computed } from "vue";
import { $tf } from "@/plugins/i18n";
export default {
  __name: 'MainChildCell',
  props: {
    node: {
      type: Object,
      required: true
    },
    isLastChild: {
      type: Boolean,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var name = computed(function () {
      var _props$node$projectDa;
      if (((_props$node$projectDa = props.node.projectData) === null || _props$node$projectDa === void 0 ? void 0 : _props$node$projectDa.name) === "error.projectNotFound|Ismeretlen projekt") {
        var _props$node$projectDa2;
        return $tf((_props$node$projectDa2 = props.node.projectData) === null || _props$node$projectDa2 === void 0 ? void 0 : _props$node$projectDa2.name);
      } else {
        var _props$node$projectDa3;
        return (_props$node$projectDa3 = props.node.projectData) === null || _props$node$projectDa3 === void 0 ? void 0 : _props$node$projectDa3.name;
      }
    });
    return function (_ctx, _cache) {
      var _props$node$projectD;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(name.value), 1), _createElementVNode("div", _hoisted_4, _toDisplayString((_props$node$projectD = __props.node.projectData) === null || _props$node$projectD === void 0 ? void 0 : _props$node$projectD.leadUserName), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref($tf)("timeManagementOverview.allocatedTime|Hozzárendelt idő")), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref($tf)("timeManagementOverview.loggedTime|Rögzített idő")), 1)]), _createElementVNode("div", {
        class: _normalizeClass(['absolute left-[-35px] top-[-1px] w-[1px] h-[calc(100%+1px)] bg-surface-200', {
          'h-[calc(80%)]': __props.isLastChild
        }])
      }, null, 2)]);
    };
  }
};